<template>
  <div class="extension-container">
    <!-- 悬浮头部 -->
    <div class="sticky-header">
      <header class="header">
        <div class="header-left">
          <div class="header-badge-icon">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 14 14"></polyline>
            </svg>
          </div>
          <p class="header-title">My Extension</p>
        </div>
        <button class="header-button" @click="goRepaymentPage">
          Full Payment
        </button>
      </header>

      <!-- 悬浮状态卡片 -->
      <div
        class="card status-card"
        style="margin-top: 10px"
        v-if="extensionInfo.extensionBoolean"
      >
        <div class="status-indicator">
          <span class="days-count">{{ extensionInfo.period }}</span>
          <span class="days-label">Extension days</span>
        </div>

        <div class="status-details">
          <div class="detail-item">
            <span class="detail-value highlight-amount"
              >${{ extensionInfo.extensionAccrStr }}</span
            >
            <span class="detail-label">Extension cost</span>
          </div>
          <div class="detail-item">
            <span class="detail-value">{{
              formatDate(extensionInfo.extensionDueDateStr)
            }}</span>
            <span class="detail-label">New due date</span>
          </div>
        </div>
      </div>
    </div>

    <main class="content">
      <!-- 延期详情卡片 -->
      <div class="card info-card" v-if="extensionInfo.extensionBoolean">
        <div class="card-header-row">
          <div class="icon-tag">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#2575FC" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
            </svg>
          </div>
          <span class="card-title-text">Extension Summary</span>
        </div>

        <div class="info-row">
          <span class="row-label">Account holder</span>
          <span class="row-val">{{ extensionInfo.titular }}</span>
        </div>

        <!-- 仿参考图的金额高亮栏 -->
        <div class="amount-feature-box">
          <span class="feature-label">Pay to Extend</span>
          <span class="feature-amount">${{ extensionInfo.extensionAccrStr }}</span>
        </div>

        <!-- Extension Payment Button -->
        <div style="margin-top: 20px; text-align: center;">
          <button
            class="primary-btn"
            @click="copyCLABE"
          >
            Extension Payment →
          </button>
        </div>
      </div>

      <!-- 无法延期提示 -->
      <div
        class="card info-card"
        style="margin-top: 20px; text-align: center;"
        v-if="!extensionInfo.extensionBoolean"
      >
        <p class="no-extension-text">
          You cannot request an extension temporarily
        </p>
      </div>

      <!-- Safe Repayment Reminder (参考图纯净安全蓝风格) -->
      <div
        class="card warning-card"
        v-if="extensionInfo.extensionBoolean"
      >
        <div style="display: flex; align-items: flex-start;">
          <div class="shield-icon-wrapper">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#2575FC" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
              <polyline points="9 12 11 14 15 10"></polyline>
            </svg>
          </div>
          <div class="warning-text-wrap">
            <p class="warning-title">
              Safe Repayment Reminder
            </p>
            <p class="warning-desc">
              Always repay using the UPIID shown in this App.
            </p>
            <p class="warning-desc" style="margin-bottom: 0;">
              Do NOT trust any UPIID shared in WhatsApp or personal messages.
            </p>
          </div>
        </div>
      </div>

      <!-- UTR Input Section -->
      <div
        class="card utr-card"
        v-if="extensionInfo.extensionBoolean"
      >
        <div class="utr-input-container">
          <div class="card-header-row" style="margin-bottom: 6px;">
            <div class="icon-tag">
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#2575FC" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </div>
            <label class="utr-label">Enter UTR Number</label>
          </div>

          <p class="utr-desc">
            After completing payment, please enter your 12-digit UTR (UPI Ref. No.) below ↓
          </p>
          <div class="input-wrapper">
            <input
              v-model="utr"
              class="utr-input"
              type="text"
              placeholder="Enter 12-digit UTR number"
              maxlength="12"
            />
            <button class="paste-btn" @click="pasteUTR">Paste</button>
          </div>
          <div class="error-message" v-if="utr && !isValidUTR()">
            Please enter a valid 12-digit UTR number
          </div>

          <!-- Success message - only shown after successful submission -->
          <div class="success-message" v-if="utrSubmitted && utrSuccessMessage">
            {{ utrSuccessMessage }}
          </div>

          <button
            class="submit-utr-btn"
            @click="submitUTR"
            :disabled="!isValidUTR()"
          >
            Submit UTR →
          </button>
        </div>
      </div>

      <!-- 4大信任背书服务保障 (参考图下半部分特征卡片) -->
      <div class="features-grid">
        <div class="feature-item">
          <div class="feature-icon">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#2575FC" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          </div>
          <span class="feature-title">Online Processes</span>
        </div>
        <div class="feature-item">
          <div class="feature-icon">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#2575FC" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
            </svg>
          </div>
          <span class="feature-title">Easy To Use</span>
        </div>
        <div class="feature-item">
          <div class="feature-icon">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#2575FC" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
              <line x1="1" y1="10" x2="23" y2="10"></line>
            </svg>
          </div>
          <span class="feature-title">Access Anytime</span>
        </div>
        <div class="feature-item">
          <div class="feature-icon">
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#2575FC" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
            </svg>
          </div>
          <span class="feature-title">Secure Data Protection</span>
        </div>
      </div>
    </main>

    <!-- 仿参考图的悬浮客服耳机球 -->
    <div class="floating-service-btn" @click="handleCustomerService">
      <div class="service-halo"></div>
      <div class="service-inner">
        <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#FFFFFF" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
          <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import CallApp from "callapp-lib";

export default {
  name: "ExtensionPage",
  data() {
    return {
      extensionInfo: {},
      bankMethods: {},
      repaymentCode: null,
      key: "",
      currentDate: "",
      expandedCategories: {},
      lastExpandedCategory: null,
      utr: "",
      utrSubmitted: false,
      utrSuccessMessage: "",
    };
  },
  mounted() {
    document.title = "My Extension";
  },
  created() {
    this.setCurrentDate();
    this.getDetailInfo();
  },
  methods: {
    formatDate(dateStr) {
      return dateStr ? dateStr.substr(0, 10) : "";
    },
    setCurrentDate() {
      const now = new Date();
      const y = now.getFullYear();
      const m = String(now.getMonth() + 1).padStart(2, "0");
      const d = String(now.getDate()).padStart(2, "0");
      this.currentDate = `${y}-${m}-${d}`;
    },
    handleCustomerService() {
      if (this.extensionInfo.customerServiceUrl) {
        window.open(this.extensionInfo.customerServiceUrl, "_blank");
      } else {
        if (this.$toast) {
          this.$toast("Support team is ready to help 24/7");
        }
      }
    },
    async getDetailInfo() {
      let keyStr = this.getParamQueryString(window.location.href, "key");
      let res = await this.$Http.getExtensionInfo(
        {
          key: keyStr,
        },
        true,
      );
      this.extensionInfo = res;

      try {
        let bankRes = await this.$Http.repaymentMethod({ key: keyStr });
        this.bankMethods = {
          "Payment Methods": Object.keys(bankRes).map((key) => ({
            repayCode: key,
            repayMethodName: key,
            selected: bankRes[key],
          })),
        };
        Object.keys(bankRes).map((key) => {
          if (bankRes[key]) {
            this.repaymentCode = key;
          }
        });
        this.initExpandedState();
      } catch (error) {
        console.error("Error fetching bank methods:", error);
      }
    },
    initExpandedState() {
      const categories = Object.keys(this.bankMethods);
      let selectedCategory = null;

      selectedCategory = categories[0];

      categories.forEach((category) => {
        const methods = this.bankMethods[category];
        const hasSelected = methods.some((method) => method.selected);
        if (hasSelected) {
          selectedCategory = category;
        }
      });

      categories.forEach((category) => {
        this.$set(this.expandedCategories, category, false);
      });

      if (selectedCategory) {
        this.$set(this.expandedCategories, selectedCategory, true);
        this.lastExpandedCategory = selectedCategory;
      } else if (categories.length > 0) {
        this.$set(this.expandedCategories, categories[0], true);
        this.lastExpandedCategory = categories[0];
      }
    },
    toggleCategory(category) {
      if (this.expandedCategories[category]) {
        this.$set(this.expandedCategories, category, false);
        this.lastExpandedCategory = null;
      } else {
        if (this.lastExpandedCategory) {
          this.$set(this.expandedCategories, this.lastExpandedCategory, false);
        }
        this.$set(this.expandedCategories, category, true);
        this.lastExpandedCategory = category;
      }
    },
    selectMethod(method) {
      Object.keys(this.bankMethods).forEach((category) => {
        this.bankMethods[category].forEach((m) => {
          this.$set(m, "selected", false);
        });
      });

      this.$set(method, "selected", true);
      this.repaymentCode = method.repayCode;
      const bankName = method.repayMethodName.includes("-")
        ? method.repayMethodName.split("-")[0]
        : method.repayMethodName;
      this.extensionInfo.repaymentBankName = bankName;
    },
    goRepaymentPage() {
      let keyStr = this.getParamQueryString(window.location.href, "key");
      this.$router.push({ path: "/repayment", query: { key: keyStr } });
    },
    getParamQueryString(url, name) {
      let subStr = name + "=";
      if (url.indexOf(subStr) !== -1) {
        let arr = url.split(subStr);
        let sub1 = arr[1];
        if (sub1.indexOf("&") !== -1) {
          let arr2 = sub1.split("&");
          return arr2[0];
        }
        return sub1;
      }
      return "";
    },
    async copyCLABE() {
      try {
        let keyStr = this.getParamQueryString(window.location.href, "key");
        let responseInfo = await this.$Http.repaymentUrl(
          {
            key: keyStr,
            repayCode: this.repaymentCode,
            extension: true,
          },
          false,
        );

        if (responseInfo && responseInfo.length > 0) {
          window.open(responseInfo, "_blank");
        }

        await this.$Http.pointH5Report(
          {
            key: keyStr,
            eventName: "click_pay_button",
          },
          true,
        );
      } catch (error) {
        console.error("Error:", error);
      }
    },
    isValidUTR() {
      return /^\d{12}$/.test(this.utr);
    },
    async pasteUTR() {
      try {
        const text = await navigator.clipboard.readText();
        if (/^\d{12}$/.test(text)) {
          this.utr = text;
        } else {
          this.utr = text;
        }
      } catch (err) {
        console.error("Failed to read clipboard contents: ", err);
      }
    },
    async submitUTR() {
      if (!this.isValidUTR()) {
        return;
      }

      try {
        let keyStr = this.getParamQueryString(window.location.href, "key");
        let response = await this.$Http.submitUrl(
          {
            key: keyStr,
            utr: this.utr,
            isExtend: true,
          },
          true,
        );

        console.log("UTR submitted successfully", response);

        if (this.$toast) {
          this.$toast.success("Success");
        } else {
          alert("Success");
        }

        this.utrSubmitted = true;
        this.utrSuccessMessage =
          response.message || "UTR submitted successfully!";
      } catch (error) {
        console.error("Error submitting UTR:", error);
        this.utrSubmitted = false;
        this.utrSuccessMessage = "";

        if (this.$toast) {
          this.$toast.fail("Failed to submit UTR");
        }
      }
    },
  },
};
</script>

<style scoped>
/* 基础容器 */
.extension-container {
  min-height: 100vh;
  background-color: transparent;
  color: #1E293B;
  padding-bottom: 50px;
  position: relative;
}

/* 悬浮头部区域 */
.sticky-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: transparent;
}

/* 头部样式：通透纯白微蓝玻璃拟态 */
.header {
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  color: #1E293B;
  padding: 16px 20px 48px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0 0 24px 24px;
  border-bottom: 1px solid rgba(220, 230, 245, 0.85);
  box-shadow: 0 8px 24px rgba(30, 80, 160, 0.04);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-badge-icon {
  width: 32px;
  height: 32px;
  border-radius: 10px;
  background: #EEF4FE;
  color: #2575FC;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-title {
  font-size: 20px;
  font-weight: 800;
  margin: 0;
  color: #1E293B;
  letter-spacing: -0.2px;
}

.header-button {
  background: #EEF4FE;
  border: 1px solid #D0E2FE;
  color: #2575FC;
  font-size: 13px;
  font-weight: 700;
  padding: 8px 16px;
  border-radius: 20px;
  cursor: pointer;
  letter-spacing: 0.2px;
  transition: all 0.2s ease;
}

.header-button:active {
  transform: scale(0.96);
  background: #E1EDFE;
}

/* 卡片通用样式：纯净无瑕白卡 + 弥散蓝调投影 */
.card {
  background: #FFFFFF;
  border-radius: 20px;
  padding: 20px;
  max-width: 600px;
  box-shadow: 0 10px 30px rgba(30, 80, 160, 0.06), 0 2px 8px rgba(0, 0, 0, 0.02);
  border: 1px solid rgba(220, 230, 245, 0.85);
  margin: 0 16px 16px;
  flex-direction: column;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.card-header-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.icon-tag {
  width: 28px;
  height: 28px;
  border-radius: 8px;
  background: #EEF4FE;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-title-text {
  font-size: 16px;
  font-weight: 800;
  color: #1E293B;
}

/* 状态卡片 */
.status-card {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 20px;
  background: #FFFFFF;
  color: #1E293B;
  margin-top: -36px;
  position: relative;
  z-index: 10;
  border: 1px solid rgba(215, 228, 245, 0.9);
  box-shadow: 0 14px 36px rgba(30, 80, 160, 0.08), 0 2px 10px rgba(0, 0, 0, 0.02);
}

.status-indicator {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 16px 0 4px;
  border-right: 1px solid #EEF3FA;
  min-width: 105px;
}

.days-count {
  font-size: 32px;
  font-weight: 800;
  line-height: 1;
  color: #2575FC;
  letter-spacing: -0.5px;
}

.days-label {
  font-size: 12px;
  margin-top: 6px;
  color: #64748B;
  font-weight: 600;
}

.status-details {
  width: 100%;
  display: flex;
  justify-content: space-around;
}

.detail-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.detail-value {
  font-size: 18px;
  font-weight: 800;
  color: #1E293B;
  margin-bottom: 4px;
  margin-top: 4px;
}

.detail-value.highlight-amount {
  color: #2575FC;
}

.detail-label {
  font-size: 12px;
  color: #64748B;
  font-weight: 500;
}

/* 内容区域 */
.content {
  padding-bottom: 40px;
  max-width: 600px;
  margin: 0 auto;
}

/* 信息卡片 */
.info-card {
  padding: 20px;
  margin: 16px 16px 0;
}

.info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 13px 16px;
  background-color: #F4F7FC;
  border-radius: 12px;
  margin-bottom: 10px;
  border: 1px solid rgba(220, 230, 245, 0.6);
  font-size: 14px;
}

.row-label {
  color: #64748B;
  font-weight: 500;
}

.row-val {
  font-weight: 700;
  color: #1E293B;
}

/* 金额高亮横槽 */
.amount-feature-box {
  background-color: #F4F7FC;
  border: 1.5px solid #D9E4F2;
  border-radius: 14px;
  padding: 14px 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
}

.feature-label {
  font-size: 14px;
  color: #64748B;
  font-weight: 600;
}

.feature-amount {
  font-size: 22px;
  font-weight: 800;
  color: #2575FC;
  letter-spacing: -0.3px;
}

.no-extension-text {
  color: #EF4444;
  font-weight: 700;
  font-size: 15px;
  margin: 8px 0;
}

/* 警示与提醒卡片 (纯净安全蓝调风格) */
.warning-card {
  padding: 16px 18px;
  margin: 16px 16px 16px;
  background: #F0F6FF !important;
  border: 1px solid #CDE0FD !important;
  border-radius: 16px !important;
  box-shadow: 0 4px 16px rgba(37, 117, 252, 0.05) !important;
}

.shield-icon-wrapper {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(37, 117, 252, 0.12);
}

.warning-text-wrap {
  flex: 1;
}

.warning-title {
  font-weight: 800;
  margin: 0 0 4px 0;
  color: #1A6EF5;
  font-size: 15px;
}

.warning-desc {
  margin: 0 0 3px 0;
  font-size: 13px;
  color: #475569;
  line-height: 1.4;
}

/* UTR Input Styles */
.utr-card {
  padding: 20px;
  margin: 0 16px 20px;
}

.utr-label {
  display: inline-block;
  font-size: 16px;
  font-weight: 800;
  color: #1E293B;
}

.utr-desc {
  font-size: 13px;
  color: #64748B;
  margin: 0 0 14px 0;
  line-height: 1.4;
}

.input-wrapper {
  display: flex;
  gap: 10px;
  margin-bottom: 14px;
}

.utr-input {
  flex: 1;
  padding: 12px 16px;
  background-color: #F4F7FC;
  border: 1.5px solid #D9E4F2;
  border-radius: 14px;
  font-size: 15px;
  outline: none;
  color: #1E293B;
  font-weight: 600;
  transition: all 0.2s;
}

.utr-input:focus {
  border-color: #2575FC;
  background-color: #FFFFFF;
  box-shadow: 0 0 0 3px rgba(37, 117, 252, 0.15);
}

.utr-input::placeholder {
  color: #94A3B8;
  font-weight: normal;
}

.paste-btn {
  background-color: #EEF4FE;
  border: 1px solid #D0E2FE;
  border-radius: 12px;
  padding: 0 18px;
  font-size: 14px;
  font-weight: 700;
  color: #2575FC;
  cursor: pointer;
  transition: all 0.2s;
}

.paste-btn:active {
  transform: scale(0.95);
  background-color: #E1EDFE;
}

.error-message {
  color: #EF4444;
  font-size: 13px;
  margin-bottom: 12px;
  font-weight: 600;
}

.success-message {
  color: #10B981;
  font-size: 13px;
  margin-bottom: 12px;
  font-weight: 600;
}

/* 主行动大按钮：对标参考图高饱和皇家蓝渐变 */
.primary-btn,
.submit-utr-btn {
  position: relative;
  width: 100%;
  background: linear-gradient(90deg, #2D87F9 0%, #1A6EF5 100%);
  color: #FFFFFF;
  border: none;
  border-radius: 16px;
  height: 52px;
  line-height: 52px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 8px 24px rgba(37, 117, 252, 0.35), 0 2px 6px rgba(0, 0, 0, 0.03);
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.primary-btn::before,
.submit-utr-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 40%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.25) 0%, transparent 100%);
  border-radius: 14px 14px 0 0;
  pointer-events: none;
}

.primary-btn:hover,
.submit-utr-btn:hover:not(:disabled) {
  box-shadow: 0 12px 30px rgba(37, 117, 252, 0.45);
  transform: translateY(-1px);
}

.primary-btn:active,
.submit-utr-btn:active:not(:disabled) {
  transform: scale(0.98);
  opacity: 0.94;
  box-shadow: 0 4px 14px rgba(37, 117, 252, 0.3);
}

.submit-utr-btn:disabled {
  background: #CBD5E1;
  color: #94A3B8;
  box-shadow: none;
  cursor: not-allowed;
}

/* 4大特征小方块卡片 */
.features-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin: 0 16px 20px;
}

.feature-item {
  background: #FFFFFF;
  border: 1px solid rgba(220, 230, 245, 0.85);
  border-radius: 16px;
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(30, 80, 160, 0.04);
}

.feature-icon {
  margin-bottom: 8px;
}

.feature-title {
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  text-align: center;
}

/* 悬浮耳机客服按钮 */
.floating-service-btn {
  position: fixed;
  bottom: 24px;
  right: 20px;
  z-index: 99;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}

.floating-service-btn:active {
  transform: scale(0.92);
}

.service-halo {
  position: absolute;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(37, 117, 252, 0.25);
  animation: pulseHalo 2s infinite ease-in-out;
}

@keyframes pulseHalo {
  0% { transform: scale(0.95); opacity: 0.6; }
  50% { transform: scale(1.15); opacity: 0.2; }
  100% { transform: scale(0.95); opacity: 0.6; }
}

.service-inner {
  position: relative;
  z-index: 2;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2D87F9 0%, #1A6EF5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(37, 117, 252, 0.4);
}
</style>
